export const calendarState = {
    startDate: undefined,
    endDate: undefined,
    isShowCalendarPanel: false,
    isBeforeDawn: false
};
export var CalendarAction;
(function (CalendarAction) {
    CalendarAction["toggleCalendarPanel"] = "toggleCalendarPanel";
    CalendarAction["UpdateDateRange"] = "UpdateDateRange";
    CalendarAction["getIsBeforeDawn"] = "getIsBeforeDawn";
})(CalendarAction || (CalendarAction = {}));
export function CalendarReducer(state = calendarState, action) {
    var _a, _b, _c, _d;
    let isShow;
    let isBeforeDawn;
    switch (action.type) {
        case CalendarAction.toggleCalendarPanel:
            isShow = typeof ((_a = action.data) === null || _a === void 0 ? void 0 : _a.isShow) === 'undefined' ? !state.isShowCalendarPanel : action.data.isShow;
            return Object.assign(Object.assign({}, state), { isShowCalendarPanel: isShow });
        case CalendarAction.UpdateDateRange:
            return Object.assign(Object.assign({}, state), { startDate: (_b = action.data) === null || _b === void 0 ? void 0 : _b.startDate, endDate: (_c = action.data) === null || _c === void 0 ? void 0 : _c.endDate });
        case CalendarAction.getIsBeforeDawn:
            isBeforeDawn = typeof ((_d = action.data) === null || _d === void 0 ? void 0 : _d.isBeforeDawn) === 'undefined' ? !state.isBeforeDawn : action.data.isBeforeDawn;
            return Object.assign(Object.assign({}, state), { isBeforeDawn });
        default:
            return state;
    }
}
